import { Component } from '@angular/core';
import { MasipService } from '../../services/masip.service';
import { AuthService } from '../../services/auth.service';
import { resolve } from 'path';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrl: './groups.component.scss',
  standalone: false
})
export class GroupsComponent {
  showDetails: boolean = false;
  groups: any[] = [];
  userFiscalId: any;
  selectedGroup: any;

  constructor(private masipService: MasipService, private authService: AuthService) { };

  ngOnInit() {
    this.masipService.setApiLoadingGlobal(false);
    if (localStorage.getItem('accessAsUser') !== null) {
      this.userFiscalId = String(localStorage.getItem('accessAsUser') || '');
    }
    this.getGroups(this.userFiscalId);
  }

  openDetails(event: any) {
    // this.lineInfo = element;
    this.selectedGroup = event;
    this.showDetails = true;

  }


  createGroup() {
    this.selectedGroup = [];
    this.showDetails = true;
  }

  changeDetails(nuevoEstado: boolean) {
    this.showDetails = nuevoEstado;
    this.groups = [];
    this.getGroups(this.userFiscalId);
  }

  getGroups(fiscalId: string) {
    this.masipService.getGroups(fiscalId).subscribe(resp => {

      resp.forEach((group: any) => {
        
        if (group.id_configuration_profile) {
          this.masipService.getProfileById(group.id_configuration_profile).subscribe((profile: any) => {
            group.profile = profile;
            this.groups.push(group);
          });
        } else {
          this.groups.push(group);
        }
      }, (error: any) => {
        console.log(error);
      });

    });
  }

}